import { FC } from 'react';

type Props = {
  color?: string;
};
const HandCoinsIcon: FC<Props> = ({ color = '#596184' }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 15H3.75V26.25H8.75V23.75M8.75 15H11.25L18.1818 17.9708C19.2848 18.4435 20 19.5281 20 20.7282V21.25M8.75 15V23.75M20 21.25H16.25L13.125 20M20 21.25H23.75C24.5833 21.25 26.25 21.75 26.25 23.75L23.8027 24.7988C19.7779 26.5237 15.2221 26.5237 11.1973 24.7988L8.75 23.75"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="22.5"
      cy="11.25"
      r="2.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="13.75"
      cy="7.5"
      r="2.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HandCoinsIcon;
